import styled from 'styled-components'
import { Row } from 'ui-cubic/dist/index.es'

const RowMargin = styled(Row)`
  margin-bottom: 20px;
`

export default RowMargin
